// v-reveal: anima o elemento (fade + deslocamento) quando ele entra na tela ao
// rolar. As classes/transições ficam em src/style.css (.reveal*).
//
//   v-reveal                          -> sobe suavemente
//   v-reveal="200"                    -> mesmo efeito, com 200ms de atraso (stagger)
//   v-reveal="{ from: 'left', delay: 100 }"
//                                     -> from: 'up' (padrão) | 'left' | 'right' | 'scale' | 'fade'
//
// Anima uma vez só (o elemento deixa de ser observado depois de aparecer).
// Sem IntersectionObserver ou com "reduzir movimento" ativo, aparece direto.
const FROM_CLASSES = {
  up: null,
  left: 'reveal-left',
  right: 'reveal-right',
  scale: 'reveal-scale',
  fade: 'reveal-fade',
}

let observer = null

const prefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches

function getObserver() {
  if (!observer) {
    observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue
        entry.target.classList.add('is-visible')
        observer.unobserve(entry.target)
      }
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' })
  }
  return observer
}

function parseOptions(value) {
  if (typeof value === 'number') return { delay: value, from: 'up' }
  return { delay: 0, from: 'up', ...(value || {}) }
}

export default {
  mounted(el, binding) {
    const { delay, from } = parseOptions(binding.value)

    if (prefersReducedMotion() || typeof IntersectionObserver === 'undefined') {
      // Sem animação: já marca como visível (filhos como .reveal-bar dependem disso).
      el.classList.add('is-visible')
      return
    }

    el.classList.add('reveal')
    if (FROM_CLASSES[from]) el.classList.add(FROM_CLASSES[from])
    if (delay) el.style.setProperty('--reveal-delay', `${delay}ms`)

    getObserver().observe(el)
  },
  unmounted(el) {
    observer?.unobserve(el)
  },
}
